$(document).ready(function(){

  $('.quotes__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:true,
    centerMode: true,
    centerPadding: '16%',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.productquotes__slider').slick({
    infinite: true,
    dots:true,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:true,
    centerMode: true,
    centerPadding: '5%',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '10%',
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '12%',
        }
      }
    ]
  });

  $('.banner__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    asNavFor: null,
    focusOnSelect:false
  });

  $('.indexproducts__slider').slick({
    infinite: false,
    dots:false,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: false,
    arrows: false,
    asNavFor: null,
    focusOnSelect:true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '5%',
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,    
          centerMode: true,
          centerPadding: '20%',
        }
      }
    ]
  });

  $('.reviews__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:false,
    centerMode: true,
    centerPadding: '20%',
  });

  $('.beforeAfter__slider-1,.beforeAfter__slider-2 ').slick({
    infinite: true,
    dots:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:false,
  });

  $('.images__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots:false,
    asNavFor: '.text__slider'
  });

  $('.text__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.images__slider',
    dots: false,
    arrows: false,
    focusOnSelect: true,
  });

  $('.instagram__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    asNavFor: null,
    focusOnSelect:true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.productinstagram__slider').slick({
    infinite: false,
    dots:false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    asNavFor: null,
    focusOnSelect:true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode:true,
          centerPadding: '20%'
        }
      }
    ]
  });

  $('.videos__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.custom-reviews__slider').slick({
    infinite: true,
    dots:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect:false,
  });

  /*if($(window).width() < 590){
    $('.template-product .columns-grid').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      focusOnSelect: true,
    });
  }*/

  var title = document.getElementsByClassName("faqs-title");
  var i;
  for (i = 0; i < title.length; i++) {
    title[i].addEventListener("click", function() {
      this.parentNode.classList.toggle("active");
      var text = this.nextElementSibling;
      if (text.style.maxHeight){
        text.style.maxHeight = null;
      } else {
        text.style.maxHeight = text.scrollHeight + "px";
      } 
    });
  }

  $('.thumbnails-slider--active .product-single__thumbnails').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    asNavFor: '.product-featured__slider',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false
        }
      }
    ]
  });

  $('.product-featured__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    focusOnSelect: true,  
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    asNavFor: '.thumbnails-slider--active .product-single__thumbnails',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          centerMode: true,
          centerPadding: '15%'
        }
      }
    ]
  });

  $('.product__video-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    focusOnSelect: true,
  });

  function refreshCart(){
    $.ajax({
      url: '/cart',
      type: "GET",
      success: function(response) {
        $(".site-header__cart-count").html($(response).find(".site-header__cart-count").html());
        $(".cart_drawer").html($(response).filter(".cart_drawer").html()).addClass("drawer_open");
        $("body").addClass("cart_drawer_open"); 
      }
    });
  }

  $(document).on('click','[data-add-to-cart]', function(e){
    /*e.preventDefault();*/
    if($(this).hasClass('disabled')){
      e.preventDefault();
      $('[data-message]').removeClass('hide');
    }else{
      $('[data-message]').addClass('hide');
      $('[data-add-to-cart-text]').addClass('hide');
      $('[data-loader]').removeClass('hide');
      var data = $(this).parents("form").serialize();
      $.ajax({
        type: "POST",
        url: "/cart/add",
        data: data,
        success: function(e) {
          $('[data-add-to-cart-text]').removeClass('hide');
          $('[data-loader]').addClass('hide');
          refreshCart();
        }
      });
    }
  });

  $(document).on("click", ".cv__outer_cart", function(e) {
    e.preventDefault();
    refreshCart();
  });
  
  $(document).on("change", "[data-item-variant] select", function(e) {
    e.preventDefault();
    $('.cv_loader').css('display','block');
    $('.cart1').css('opacity','0.5');
    var id = $(this).val();
    var t = $(this).parent().attr("data-line");
    $.ajax({
      url: t,
      type: "GET",
      success: function(e) {
        $.ajax({
          type: "POST",
          url: "/cart/add",
          data: {'id':id,'quantity':1},
          success: function(e) {
            $('.cv_loader').css('display','none');
            $('.cart1').css('opacity','1');
            $(".site-header__cart-count").html($(e).find(".site-header__cart-count").html());
            $(".cart_drawer").html($(e).filter(".cart_drawer").html());
          }
        });
      }
    });
  });

  $(document).on("click", ".cv_cart_remove", function(e) {
    e.preventDefault();
    var t = $(this).attr("href");
    $.ajax({
      url: t,
      type: "GET",
      success: function(e) {
        $(".site-header__cart-count").html($(e).find(".site-header__cart-count").html());
        $(".cart_drawer").html($(e).filter(".cart_drawer").html());
      }
    });
  });

});

$(document).click(function(e) {
  $(e.target).closest(".cart_drawer, .cv__outer_cart").length || ($(".cart_drawer").removeClass("drawer_open"), $("body").removeClass("cart_drawer_open"));
})

$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if($('.show__sticky-atc').length > 0){
    var atc = $('.show__sticky-atc').offset().top;
    if (scroll > atc) {
      $('.product-sticky__atc').addClass("sticky");
    } else {
      $('.product-sticky__atc').removeClass("sticky");
    }
  }

  if($(window).width() < 750 && scroll > 100){
    $('#shopify-section-header').addClass('fixed__header');
  }else{
    $('#shopify-section-header').removeClass('fixed__header');
  }
});

$('[data-scroll]').on('click', function(e) {
  e.preventDefault();
  var $section = $($(this).attr('href'));
  $('html, body').animate({
    scrollTop: $section.offset().top - 100
  }, 500);
});

$('.products-swatches label').hover(function(){
  var isrc = $(this).attr('data-image');
  var href = $(this).attr('data-url');
  $(this).parent().siblings('.variant_redirect').attr('href',href);
  $(this).parents('.products-details-block').siblings().find('img').attr('src',isrc);
  $(this).parents('.products-details-block').siblings('.variant_redirect').attr('href',href);
});

$('.collection-swatches label').hover(function(){
  var isrc = $(this).attr('data-image');
  var href = $(this).attr('data-url');
  $(this).parents('.product-card').find('.variant_redirect').attr('href',href);
  $(this).parents('.cv_rel_product_desc').siblings('.image_container').children('.product-card__image-with-placeholder-wrapper').find('img').attr('src',isrc);
});

$('.swatch-element.color.available').click(function(){
  var color = $(this).attr('data-value');
  setTimeout(function(){
    $('.selected-swatch__value').html(color);
  },200);
  $('[data-add-to-cart]').removeClass('disabled');
  $('[data-message]').addClass('hide');
});

$('.banner-swatches .swatch-element.color.available').click(function(){
  $(this).siblings().removeClass('active__swatch').children('input').removeAttr('checked');
  $(this).addClass('active__swatch').children('input').attr('checked',true);
});

$('.banner-cta a').click(function(e){
  e.preventDefault();
  setTimeout(function(){
    $('.product-form__cart-submit').trigger('click');
  },200);
});

$('.product__video-slide img').click(function(e){
  e.preventDefault();
  var videoType = $(this).attr('data-type');
  if(videoType == 'vimeo'){
    var src = $(this).attr('data-vimeo-src');
  }else{
    var src = $(this).attr('data-youtube-src');
  }
  setTimeout(function(){
    $("#video_iframe").attr("src",src);
  },200);
});

$(document).on('click','.cv__change_image',function(){
  var id = $(this).attr('data-image-id');
  setTimeout(function(){
    $('.product-single__photo--has-thumbnails').removeClass('hide');
  },200);
  $('.product-single__photo--has-thumbnails').each(function(){
    if($(this).parents('.slick-slide').hasClass('slick-cloned')){
    }else{
      if($(this).attr('data-image-id') == id){
      var s = $(this).parents('.slick-slide').attr('data-slick-index');
        $('.product-featured__slider').slick("slickGoTo", s, !0);
      }
    }    
  });
  if($(window).width() < 750){
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: 0
      }, 500);
    },300);
  }
});

$('.thumbnails-slider--active .product-single__thumbnails').on('click', '.slick-slide a', function (e) {
  e.stopPropagation();
  var index = $(this).parents('.slick-slide').data("slick-index");
  console.log(index);
  if ($('.thumbnails-slider--active .product-single__thumbnails').slick('slickCurrentSlide') !== index) {
    e.preventDefault();
    $('.thumbnails-slider--active .product-single__thumbnails').slick('slickGoTo', index);
  }
});